module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-hero-1920x1080-9c15d9d9306f18a0ff7d5eaa92624431.jpg";